import { Route, RouteObject } from 'react-router-dom';
import OutstandingLandingPage from './components/landing/landing';
import { OutstandingAccountDetailPage } from './components/details/details';
import BulkNoticeCreate from './components/create/bulkNotice/create';
import BulkRemindersCreate from './components/create/bulkReminders/create';
import AuditTrailLandingPage from './components/auditTrail/landing/landing';


export interface outstandingRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: outstandingRoute[];
}

export const outstandingRoutes: outstandingRoute[] = [
  {
    path: 'cx/outstanding',
    element: <OutstandingLandingPage />,
  },
  {
    path: 'cx/outstanding/:consumerNumber',
    element: <OutstandingAccountDetailPage />,
  },
  {
    path: 'cx/outstanding/create/bulk-notice',
    element: <BulkNoticeCreate />,
  },
  {
    path: 'cx/outstanding/create/bulk-reminder',
    element: <BulkRemindersCreate />,
  },
  {
    path: 'cx/outstanding/audit-trail',
    element: <AuditTrailLandingPage />,
  }
];
